import angular from "angular";

angular
    .module('app')
    .component('organizationInviteForm', {
        template: require('./organization-invite-form.html'),
        controller: ['notify', 'notifier', '$http', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&',
        }
    });

function controller(notify, notifier, $http) {

    const $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.organization = $ctrl.resolve.organization;

        $ctrl.secret = $ctrl.organization.secret;

        $ctrl.inviteEmail = '';
    };

    $ctrl.copySecret = () => {
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText($ctrl.secret);
        } else {
            let textArea = document.createElement("textarea");
            textArea.value = $ctrl.secret;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            new Promise((res, rej) => {
                document.execCommand('copy') ? res() : rej();
                textArea.remove();
            });
        }

        notify({
            message: 'Скопирован в буфер обмена',
            duration: 2000,
            classes: 'alert-info',
            position: 'right'
        });
    }

    $ctrl.sendInvite = () => {
        $ctrl.inviteLoading = true;

        $http
            .post(`/control/send-invite`, {email: $ctrl.inviteEmail})
            .then(res => {
                notify({
                    message: 'Успешно отправлен',
                    duration: 2000,
                    classes: 'alert-success',
                    position: 'center'
                });
            })
            .catch(err => {
                notifier.errorResponseNotify(err);
            })
            .finally(() => {
                $ctrl.inviteLoading = false;
            });
    };
}



// WEBPACK FOOTER //
// ./resources/assets/modules/components/organization-invite-form/organization-invite-form.js